import {useSearchParams} from 'react-router-dom';
import {ResourceType} from '../@types/resource-type';

export interface UrlAction {
    action: 'openModel' | 'openTab' | 'shareModel';
    type: ResourceType;
    id: string;
    parentId?: string; // For nested resources like event sequences
}

export const useUrlActions = (): {
    getUrlAction: () => UrlAction | null;
    clearUrlAction: () => void;
    generateShareLink: (resourceType: ResourceType, resourceId: string, parentId?: string) => string;
} => {
    const [searchParams, setSearchParams] = useSearchParams();

    const getUrlAction = (): UrlAction | null => {
        const action = searchParams.get('action');
        const type = searchParams.get('type');
        const id = searchParams.get('id');

        if (!action || !type || !id) return null;

        return {
            action: action as UrlAction['action'],
            type: type as ResourceType,
            id,
            parentId: searchParams.get('parentId') || undefined
        };
    };

    const clearUrlAction = (): void => {
        // Remove action params but keep other params
        searchParams.delete('action');
        searchParams.delete('type');
        searchParams.delete('id');
        searchParams.delete('parentId');
        setSearchParams(searchParams);
    };

    const generateShareLink = (resourceType: ResourceType, resourceId: string, parentId?: string): string => {
        const baseUrl = `${window.location.origin}/isam/react/workspace`;
        const params = new URLSearchParams({
            action: 'openModel',
            type: resourceType,
            id: resourceId.toString()
        });

        if (parentId) {
            params.append('parentId', parentId.toString());
        }

        return `${baseUrl}?${params.toString()}`;
    };

    return { getUrlAction, clearUrlAction, generateShareLink };
};